import PropTypes from 'prop-types';

export const ShippingServicePropType = PropTypes.shape({
  serviceId: PropTypes.string,
  labelProviderId: PropTypes.string,
  carrierId: PropTypes.string,
  name: PropTypes.string,
  features: PropTypes.shape({
    supportsMultiPackage: PropTypes.bool,
    supportsReturnLabels: PropTypes.bool,
    optionCodes: PropTypes.arrayOf(PropTypes.string),
  }),
  sellerLabelProviderId: PropTypes.string,
});

/**
 * @typedef {object} ShippingServicePropType
 * @property {string} serviceId
 * @property {string} labelProviderId
 * @property {string} carrierId
 * @property {string} name
 * @property {object} features
 * @property {boolean} features.supportsMultiPackage
 * @property {boolean} features.supportsReturnLabels
 * @property {string[]} features.optionCodes
 * @property {string} sellerLabelProviderId
 */
